import React from 'react';
import { Link } from 'react-router-dom';
import { HammerIcon, GlassesIcon, RefreshCwIcon, WalletIcon, InfinityIcon } from 'lucide-react';
import { guaranteePoints, GuaranteePoint } from '../data/product';
import { GoldMedal } from './LifetimeSeal';
import { CtaButton } from './CtaButton';
const icons: Record<GuaranteePoint['icon'], React.ComponentType<{
  className?: string;
}>> = {
  hammer: HammerIcon,
  lens: GlassesIcon,
  repeat: RefreshCwIcon,
  wallet: WalletIcon
};
export function GuaranteeSection() {
  return <section id="guarantee" className="scroll-mt-28 border-b border-white/10 bg-ink-950" data-id="element-219" data-mp="nst83qhv6ryi">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-220" data-mp="slvr54p0mj0g">
        <div className="border-2 gold-edge bg-ink-900" data-id="element-221" data-mp="xkgs56c3d6py">
          <div className="relative gold-plate px-6 py-6 text-ink-950 lg:px-10 lg:py-8 lg:pr-56" data-id="element-222" data-mp="xm1mauuhunna">
            <Link to="/legal/guarantee" aria-label="Read the lifetime free replacement terms" className="absolute right-8 top-1/2 hidden -translate-y-1/2 items-center transition-transform duration-150 ease-grit hover:-translate-y-[calc(50%+3px)] focus:outline-none focus-visible:ring-2 focus-visible:ring-ink-950 lg:flex" data-id="element-223" data-mp="12gxi862upv5o">
              <GoldMedal size={140} data-id="element-224" data-mp="1vu9crswgveep" />
            </Link>
            <p className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.24em]" data-id="element-225" data-mp="1rsnu1qx945wl">
              <InfinityIcon className="h-4 w-4" aria-hidden="true" data-id="element-226" data-mp="2oioexeui228m" />
              The GritVue lifetime promise
            </p>
            <h2 className="grit-headline mt-3 text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase" data-id="element-227" data-mp="2jkmzr5072n2f">
              Break it and we
              <br data-id="element-228" data-mp="2eq8xqjr11hos" />
              replace it. Free. Forever.
            </h2>
            <p className="mt-3 max-w-2xl text-base font-bold sm:text-lg" data-id="element-229" data-mp="2aqrrvp7ouij3">
              Buy your X1 once. If it ever breaks, cracks, stops charging or you scratch a lens, we send you a new
              one at no cost, for as long as you own it.
            </p>
            <p className="mt-4 inline-flex bg-ink-950 px-4 py-2.5 font-display text-lg font-extrabold uppercase leading-tight tracking-wide text-[#ffe79a] sm:text-2xl" data-id="element-230" data-mp="10kdwibpp01h8">
              You never buy work glasses or a headlamp again. Ever.
            </p>
          </div>

          <ul className="grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-231" data-mp="vtxhwoa4y9ta">
            {guaranteePoints.map(point => {
            const Icon = icons[point.icon];
            return <li key={point.title} className="flex h-full flex-col bg-ink-900 p-6" data-id="element-232" data-mp="mt915ltcxvcp">
                  <Icon className="h-7 w-7 text-[#f2c94c]" aria-hidden="true" data-id="element-233" data-mp="mqwfaxkhb0ud" />
                  <h3 className="mt-5 font-display text-2xl font-bold uppercase leading-tight text-offwhite" data-id="element-234" data-mp="7xt8nl8fe7if">
                    {point.title}
                  </h3>
                  <p className="mt-2 text-[15px] text-steel-400" data-id="element-235" data-mp="22b2jphgme12s">{point.body}</p>
                </li>;
          })}
          </ul>

          <div className="flex flex-col gap-5 border-t border-white/10 p-6 lg:flex-row lg:items-center lg:justify-between lg:p-10" data-id="element-236" data-mp="276q8hvr6ws7r">
            <p className="grit-headline text-[clamp(1.75rem,5vw,3rem)] font-extrabold uppercase text-offwhite" data-id="element-237" data-mp="3msk1yppu7vu9">
              You will never pay for
              <br data-id="element-238" data-mp="5cv6duyty57w" />
              <span className="gold-text" data-id="element-239" data-mp="5dddjmn163ul">work light again.</span>
            </p>
            <CtaButton offer="trio" className="w-full lg:w-auto" data-id="element-240" data-mp="jiqqac4p8ra">Get 3 X1 Systems for $99.90</CtaButton>
          </div>

          <p className="border-t border-white/5 px-6 pb-5 text-[11px] leading-relaxed text-steel-600 lg:px-10" data-id="element-241" data-mp="aan8tix3p9qc">
            Lifetime Replacement Warranty ($19.95 value) included free with every multi-pack. Single systems carry 1-year replacement coverage. Original purchaser, damage and functional failure.{' '}
            <Link to="/legal/guarantee" className="underline hover:text-steel-400" data-id="element-242" data-mp="2q1j5vrbhiid2">
              Full terms
            </Link>
            .
          </p>
        </div>
      </div>
    </section>;
}